window.CreateTable = function (conf) {
    var interval;
    $.fn.dataTable.ext.errMode = 'throw';
    if (window.accordionExists) {
        interval = setInterval(function () {
            if (window.accordionDone) {
                init(conf);
                clearInterval(interval);
            }
        }, 10)
    } else {
        init(conf);
    }

    function init(conf) {
        if (!window.dataTables)
            window.dataTables = {};

        window.dataTables[conf.tableId] = $('#' + conf.tableId).DataTable(conf.dataTableConf);

        $('.initially-hidden').removeClass('initially-hidden');

        window.dataTables[conf.tableId].responsive.recalc();
        window.dataTables[conf.tableId].columns.adjust().draw();
    }
}